import { numberWithCommas, MethodList, GetParamsData, SetStorage, GetStorage } from '$Deposits/lib/LibCommonData'
import moment from 'moment'
import { setFEWalletParam } from '../../../../platform.pay.config'
import { moneyReg, CCNumberReg, CCPINReg, OldBankSixNumReg, refNoReg, VCBrefNoReg, TECrefNoReg, SACrefNoReg} from "$Deposits/lib/Reg";
import { PayApiPort } from '../../Api'
import {
    GetMethodsActive,
    GetDepositTimeSelect,
    GetDepositDateSelect,
    GetDepositPayments,
    GetUploadFileList,
    GetMethodCodeActive,
    GetMenber,
    // GetMethodsDetails,
    GetDepositBankActive,
    // GetDepositMemberBanksActive,
    // GetDepositPayments,
    GetDepositMoneyStatus,
} from './DepositUpdate'
//获取存款方式
export const GetMethods = (activeMethods = '指定methods') => {

    return (dispatch, getState) => {
        const { toastTip, ApiGet } = GetParamsData()
        toastTip.loading('Đang tải...')
        dispatch(RemoveAllReducers())
        dispatch(SetDepositSuccessPage())
        dispatch(GetDepositMemberBanks())//获取个人银行信息
        dispatch(GetMemberInfo())//获取个人信息
        

        return ApiGet(`${PayApiPort.Methods}transactionType=Deposit&`)
            .then((res) => {
                toastTip.hide()
                let result = res && res.result || { paymentMethods: [] }
                if (res && res.isSuccess && result.paymentMethods) {
                    let paymentMethods = []
                    result.paymentMethods.forEach((item) => {
                        if (MethodList.includes(item.code || '')) {
                            paymentMethods.push(item)
                        }
                    })
                    result.paymentMethods = paymentMethods
                    const active = paymentMethods.find((v) => { return v.code == activeMethods }) || false
                    const codes = active || paymentMethods[0] && paymentMethods[0]
                    codes && dispatch(SetMethodsActive(codes));//设定当前存款方式
                }

                const action = { type: 'METHODS', data: result }
                return dispatch(action)
            })
            .catch((error) => {
                console.log(error)
                toastTip.error('error...', 2)
                const action = { type: 'METHODS', data: { paymentMethods: [] } }
                return dispatch(action)
            });
    };
}

let DepostNamePiwik = {
    LB: 'Local Bank',
    QD: 'Express',
    LBQR: 'LBQR',
    FP: 'Fast Pay',
    MMO: 'MoMo Pay',
    ZLP: 'Zalo Pay',
    VP: 'Viettel Pay',
    PHC: 'Mobile Load',
    BQR: 'BQR',
    CC: 'Mobile Card',
    CTC: 'CTC'
}
let DepostUrlPiwik = {
    LB: 'local_bank',
    QD: 'express',
    LBQR: 'lbqr',
    FP: 'fast_pay',
    MMO: 'momo_pay',
    ZLP: 'zalo_pay',
    VP: 'viettel_pay',
    PHC: 'mobile_load',
    BQR: 'bqr',
    CC: 'mobile_card',
    CTC: 'ctc'
}
//设置当前存款方式
export const SetMethodsActive = (data) => {
    const {webPiwikEvent, webPiwikUrl, appPiwikEvent, device} = GetParamsData();
    let methodsActive = data
    const methodCode = methodsActive.availableMethods && methodsActive.availableMethods[0] && methodsActive.availableMethods[0].methodCode || 'DEFAULT'
    return (dispatch, getState) => {
        const { DepositTriggerFrom = {} } = getState();
        const { from, vendor = {} } = DepositTriggerFrom;
        if (device === 'APP') {
            appPiwikEvent({
                category: from === "inGame" ? `In${vendor?.piwikName}` : 'Deposit',
                action: from === "inGame" ? `Switch to ${data?.code}` : `Switch to ${data?.code}`,
                name: from === "inGame" ? `In${vendor?.piwikName}_C_${data?.code}` : `Deposit_C_${data?.code}`,
                path: from === "inGame" ? `In${vendor?.piwikName}`.toLocaleLowerCase() : 'deposit',
                title: from === "inGame" ? `In${vendor?.piwikName}` : 'Deposit',
            })
        } else {
            if (from === "inGame") {
                webPiwikEvent(`In${vendor?.piwikName}`, `Switch to ${data?.code}`, `In${vendor?.piwikName}_C_${data?.code}`);
            }
            if (!vendor?.piwikName) {
                webPiwikEvent("Deposit", `Switch to ${data?.code}`, `Deposit_C_${data?.code}`);
                webPiwikUrl(`deposit_${DepostUrlPiwik[data?.code]}`, `${DepostNamePiwik[data?.code]} Deposit Page`)
            }
        }
        const action = {
            type: 'METHODS_ACTIVE',
            data: { methods: data.code, ...data },
        };
        dispatch(action);
        dispatch(GetMethodsDetails(methodsActive.code, methodCode));//获取存款详情
        dispatch(SetMethodCodeActive(methodCode));//设置渠道
        return
    }

}
export const RemoveMethodsActive = () => {
    return (dispatch, getState) => {
        const action = {
            type: 'METHODS_ACTIVE',
            data: {},
        };
        return dispatch(action);
    }

}
//支付渠道，默认是第一个availableMethods
export const SetMethodCodeActive = (data = 'DEFAULT', methods = '') => {
    return (dispatch, getState) => {
        if (methods) {
            //有methods表示切换渠道，要重新call api拿details
            dispatch(GetMethodsDetails(methods, data));//获取存款详情
        }
        const {MethodsActive, DepositTriggerFrom} = getState();
        const { from } = DepositTriggerFrom;
        if (from != "inGame") {
            if(MethodsActive.code==="LB"){
                const {webPiwikEvent, webPiwikUrl} = GetParamsData();
                webPiwikEvent("Deposit", "Switch Method", `Deposit_LB_C_${data}`)
                webPiwikUrl(`deposit_${MethodsActive.code.toLocaleLowerCase()}_${data.toLocaleLowerCase()}`, `${MethodsActive.code} ${data} Deposit Page`)
            }
            if(MethodsActive.code==="CTC"){
                const {webPiwikEvent} = GetParamsData();
                webPiwikEvent("Deposit", `Switch to ${data.slice(0,1).toUpperCase()+data.slice(1).toLowerCase()} Flow`, `Deposit_CTC_C_${data.slice(0,1).toUpperCase()+data.slice(1).toLowerCase()} flow`)
            }
        }
        const action = {
            type: 'METHOD_CODE_ACTIVE',
            data: data,
        };
        return dispatch(action);
    }
}


//获取存款详情{LB: {...}, PPB: {...}}
const BbanksBankAccounts = { LB: 'bankAccounts', MMbankAccounts: 'bankAccounts', FP: 'banks', VP: 'banks', MMO: 'banks', LBQR: 'banks', MMLB: 'bankAccounts', PHC: 'banks', QD: 'bankAccounts', BQR: 'bankAccounts', CTC: 'banks' }

export const GetMethodsDetails = (methods = 'LB', methodCode = 'DEFAULT') => {
    return (dispatch, getState) => {

        const { toastTip, ApiGet, device } = GetParamsData();

        if(device && device.toLowerCase() === "web") {
            dispatch(SetDepositSuccessPage(false));
        } else {
            dispatch(RemoveAllReducers())//切换存款方式清空已填写数据
        }
        
        if (methodCode == 'CHANNEL') {
            //CHANNEL虚拟币默认不选择
            dispatch(SetDepositBankActive())
        }
        toastTip.loading('Đang tải...')
        dispatch(SetBanksBankAccounts([{
            dummy: 'dummy'
        }]))
        return ApiGet(`${PayApiPort.DetailsDeposit}transactionType=Deposit&method=${methods}&methodCode=${methodCode}&`)
            .then((res) => {
                toastTip.hide()
                //设置methods为key，
                let dataList = { bankAccounts: '', banks: '', setting: '', transferTypes: '', payoutDurations: '', suggestedAmounts: '' }
                if (res) {
                    dataList = res.result || {}
                }
                let bankList = res.result[BbanksBankAccounts[methods] || 'bankAccounts'] || [].filter(v => ['FP', 'LBQR', 'BQR', 'QD'].includes(methods) ? !v.isUnderMaintenance : true)
                
                bankList = bankList.map((item) => {
                    const { bankCode, id } = item
                    const bankId = bankCode || id || 'bankId'
                    //自定义bankId，用于web的bank选择
                    return {...item, ...{bankId}}
                })
                dispatch(SetBanksBankAccounts(bankList))//设置bank数据(banks/bankAccounts)
                let activeBank = methodCode == 'CHANNEL' ? {} : (bankList[0] || {})//CHANNEL虚拟币默认不选择
                if(dataList.setting?.isAutoAssign && (methods == 'BQR' || methods == 'QD' || methods == 'LB')) {
                    //RD, BQR, LB 需要使用isAutoAssign， isAutoAssign = true 时候不显示公司收款银行
                    activeBank = { isAutoAssign: true }
                }
                dispatch(SetDepositBankActive(activeBank))//默认选择第一个
                const action = { type: 'METHODS_DETAILS', data: dataList }
                return dispatch(action)

            })
            .catch((error) => {
                console.log('error in GetMethodsDetails ',error)
                toastTip.error('error...', 2)
                //设置methods为key，
                dispatch(SetBanksBankAccounts([]))
                let dataList = { bankAccounts: '', banks: '', setting: '', transferTypes: '', payoutDurations: '', suggestedAmounts: '' }
                const action = { type: 'METHODS_DETAILS', data: dataList }
                return dispatch(action)
            });
    };
}
export const GetSuggestedAmounts = (methods = 'LB', methodCode = 'DEFAULT', bankCode = 'ZING') => {
    return (dispatch, getState) => {
        const { toastTip, ApiGet } = GetParamsData()
        dispatch(SetDepositMoneyStatus('', '', true))
        toastTip.loading('Đang tải...')
        return ApiGet(`${PayApiPort.SuggestedAmounts}amount=2&method=${methods}&methodCode=${methodCode}&bankCode=${bankCode}&`)
            .then((res) => {
                toastTip.hide()
                let dataList = []
                if (res.isSuccess) {
                    dataList = res.result || []
                }
                const action = { type: 'SUGGESTED_AMOUNTS', data: dataList }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('error...', 2)
                const action = { type: 'SUGGESTED_AMOUNTS', data: [] }
                return dispatch(action)
            });
    };
}

//存款银行数据bankAccounts/banks
export const SetBanksBankAccounts = (data) => {
    const action = {
        type: 'BANKS_BANKACCOUNTS',
        data: data,
    };
    return action;
}

//银行搜索
export const SetDepositBankSearch = (key,) => {
    const action = {
        type: 'DEPOSIT_BANK_SEARCH',
        data: key,
    };
    return action;
}

//选中的存款银行
export const SetDepositBankActive = (data = {}, suggestedAmounts = {}) => {
    return (dispatch, getState) => {
        const { webPiwikEvent} = GetParamsData()
        const { methods } = GetMethodsActive()
        const { methodCode } = GetMethodCodeActive()
        const {MethodsActive, MethodCodeActive} = getState();
        const bankCode = data?.code || '';
        if(MethodsActive.code==="CTC" && MethodCodeActive==="CHANNEL" && data?.code){
            webPiwikEvent(`Deposit`, `Switch to ${data?.code}`, `Deposit_Channelflow_C_${data?.code}`)
        }
        if (methods && methods == 'PHC' && bankCode) {
            //特殊金额获取
            dispatch(GetSuggestedAmounts(methods, methodCode, bankCode))
        }
        const action = {
            type: 'DEPOSIT_BANK_ACTIVE',
            data: data,
        };
        return dispatch(action);
    }
}

//存款金额判断
export const SetDepositMoneyStatus = (data = '', MethodsDetails = {}, isRefresh = false) => {
    if (isRefresh) {
        const moneyStatus = { money: '', moneyErrMsg: '' }
        const action = {
            type: 'DEPOSIT_MONEY_STATUS',
            data: moneyStatus,
        };
        return action;
    }

    const { minBal, maxBal } = MethodsDetails.setting || {}
    const money = data && data.toString().replace(/[^\d]/g, '') || '';
    let moneyErrMsg = ''
    if (money == '' || money == 0) {
        moneyErrMsg = 'Vui lòng nhập số tiền gửi'
    } else if (!moneyReg.test(money)) {
        moneyErrMsg = 'Vui lòng nhập số tiền gửi'
    } else {
        // M3 1 = 1,000
        // const actualMoney = Number(money) * 1000;
        if (money > maxBal) {
            moneyErrMsg = 'Số tiền không được vượt quá ' + numberWithCommas(maxBal) + ' đ'
        } else if (money < minBal) {
            moneyErrMsg = 'Số tiền không được ít hơn ' + numberWithCommas(minBal) + ' đ'
        }
    }

    const moneyStatus = { money, moneyErrMsg }
    const action = {
        type: 'DEPOSIT_MONEY_STATUS',
        data: moneyStatus,
    };
    return action;
}
//旧账户后6位数
export const SetDepositOldBankSixNumberStatus = (tempData = '', isRefresh = false) => {
    const data = tempData && tempData.toString().replace(/[^\d]/g, '') || ''
    if (isRefresh) {
        const codeStatus = { numCode: '', codeErrMsg: '' }
        const action = {
            type: 'DEPOSIT_OLD_BANK_SIX_NUMBER_STATUS',
            data: codeStatus,
        };
        return action;
    }
    let codeErrMsg = ''
    if (data == '' || data == 0) {
        codeErrMsg = '6 chữ số cuối không được để trống'
    } else if (!OldBankSixNumReg.test(data)) {
        codeErrMsg = 'Số tài khoản cũ không được ít hơn 6 chữ số'
    }

    const action = {
        type: 'DEPOSIT_OLD_BANK_SIX_NUMBER_STATUS',
        data: { numCode: data, codeErrMsg },
    };
    return action;
}
//获取用户银行卡
export const GetDepositMemberBanks = () => {

    return (dispatch, getState) => {
        const { toastTip, ApiGet } = GetParamsData()
        return ApiGet(PayApiPort.MemberBanks + 'accountType=All&')
            .then((res) => {
                if (res && res.isSuccess) {
                    let bankList = []
                    let result = res.result || []
                    let { DepositMemberBanks } = getState()//FP5-1785

                    let oldDefault = DepositMemberBanks.find(v => v.isDefault)?.iidd
                    let newDefault = result.find(v => v.isDefault)?.iidd
                    let defaultBankIndex = result.findIndex(v1 => !DepositMemberBanks.find(v2 => v2.iidd == v1.iidd))
                    if (oldDefault && newDefault && oldDefault == newDefault && result.length != DepositMemberBanks.length && defaultBankIndex >=0) {//之前已经设置default， 本次没有设置,并将最新添加的银行卡放到第一位
                        let tempObj = result[defaultBankIndex]
                        result[defaultBankIndex] = ''
                        result.unshift(tempObj)
                        bankList = result.filter(Boolean)
                    } else {
                        let defaultBankIndex = result.findIndex(v => v.isDefault)
                        if (defaultBankIndex >= 0) {
                            let tempObj = result[defaultBankIndex]
                            result[defaultBankIndex] = ''
                            result.unshift(tempObj)
                            bankList = result.filter(Boolean)
                        } else {
                            bankList = result
                        }
                    }

                    //选中isDefault，没有默认第一个
                    const isDefault = bankList[0] || {}
                    dispatch(SetDepositMemberBanksActive(isDefault))
                    const action = { type: 'DEPOSIT_MEMBER_BANKS', data: bankList }
                    return dispatch(action)
                }
            })
            .catch((error) => {
                const action = { type: 'DEPOSIT_MEMBER_BANKS', data: [] }
                return dispatch(action)
            });
    };
}

//选中的存款银行
export const SetDepositMemberBanksActive = (data = {}) => {
    const action = {
        type: 'DEPOSIT_MEMBER_BANKS_ACTIVE',
        data: data,
    };
    return action;
}
//存款日期选择
export const SetDepositDateSelect = (data = '') => {
    const action = {
        type: 'DEPOSIT_DATE_SELECT',
        data: data,
    };
    return action;
}
//存款时间选择
export const SetDepositTimeSelect = (data = '') => {
    const action = {
        type: 'DEPOSIT_TIME_SELECT',
        data: data,
    };
    return action;
}
export const SetDepositNextStep = (data = false) => {
    const action = {
        type: 'DEPOSIT_NEXT_STEP',
        data: data,
    };
    return action;
}
//上传图片list
let UploadFileList = []
export const SetUploadFileList = (data = {}, deletes = false) => {
    let errMsg = ''
    if (deletes) {
        //删除
        // const deleteIndex = UploadFileList.findIndex((v) => { return (v.fileName == data.fileName) })
        // UploadFileList = [...UploadFileList.slice(0, deleteIndex), ...UploadFileList.slice(deleteIndex + 1)]

        // 目前只上传一个图片
        UploadFileList = []
    } else {
        //添加
        const { fileName, fileSize, fileBytes, error = '', uri } = data
        const lastIndex = fileName && fileName.lastIndexOf('.') || -1
        const fileType = ['JPG', 'JPEG', 'PNG', 'GIF', 'PDF', 'HEIC', 'HEIF']
        if(error) {
            errMsg = 'Rất tiếc đã xảy ra lỗi trong quá trình đăng tải biên lai, vui lòng thử lại'
        } else if (!fileName || !fileBytes) {
            errMsg = `Loại tệp hoặc kích thước tệp không hợp lệ. Vui lòng kiểm tra và tải lại`
        } else if (fileSize > 1024 * 1024 * 4) {
            errMsg = `Loại tệp hoặc kích thước tệp không hợp lệ. Vui lòng kiểm tra và tải lại`
        } else if (!fileType.includes(fileName.substr(lastIndex + 1).toUpperCase())) {
            errMsg = `Loại tệp hoặc kích thước tệp không hợp lệ. Vui lòng kiểm tra và tải lại`
        } else {
             // 目前只上传一个图片
            // UploadFileList = [...UploadFileList, { fileName: fileName, fileBytes: fileBytes }]
            UploadFileList = [{ fileName: fileName, fileBytes: fileBytes }]
        }
    }

    return (dispatch, getState) => {
        dispatch(SetUploadFileErr(errMsg));//错误提示
        const action = {
            type: 'UPLOAD_FILE_LIST',
            data: UploadFileList,
        };
       // console.log(UploadFileList,123999990)
        return dispatch(action);
    }
}
//清除全部图片
export const RemoveUploadFile = () => {
    UploadFileList = []
    const action = {
        type: 'UPLOAD_FILE_LIST',
        data: [],
    };
    return action;
}
//上传图片错误
export const SetUploadFileErr = (data = '') => {
    const action = {
        type: 'UPLOAD_FILE_ERR',
        data: data,
    };
    return action;
}
//存款第二部确认
export const PostConfirmStep = (data = {}) => {
    const uploadFile = GetUploadFileList() || []
    const { accountNumber = '' } = data.returnedBankDetails || {}
    const transactionId = data.transactionId || ''
    const { fileName, fileBytes } = uploadFile[0] || {}

    const postData = {
        "depositingBankAcctNum": accountNumber.slice(-6),
        "offlineDepositDate": moment(new Date()).format('MM/DD/YYYY') + ' ' + moment(new Date()).format('HH:mm'),
        "fileName": fileName || '',
        "fileByte": fileBytes || '',
        'hasQR': false,
    }
    return (dispatch, getState) => {
        const { toastTip, ApiPost } = GetParamsData()
        return ApiPost(PayApiPort.ConfirmStep + 'transactionId=' + transactionId + '&', postData)
            .then((res) => {
                if (res.isSuccess) {
                    if(fileBytes)
                        toastTip.success('Đăng Tải Thành Công', 2)
                } else {
                    toastTip.error('error...')
                }
                const action = {
                    type: 'POST_UPLOAD_FILE',
                    data: res,
                };
                return dispatch(action)

            })
            .catch((error) => {
                const action = {
                    type: 'POST_UPLOAD_FILE',
                    data: {},
                };
                return dispatch(action)
            });
    };

}
//清除存款数据
export const ClearDepositPayments = (data = {}) => {
    const action = {
        type: 'CLEAR_DEPOSIT_PAYMENTS',
        data: data,
    };
    return action;
}
//显示成功页面
export const SetDepositSuccessPage = (data = false) => {
    return (dispatch, getState) => {
        dispatch(SetDepositNextStep());
        dispatch(SetDepositOldBank());
        if (!data) {
            //关闭成功页面清除存款数据
            dispatch(RemoveAllReducers());
        }
        const action = {
            type: 'DEPOSIT_SUCCESS_PAGE',
            data: data,
        };
        return dispatch(action);
    }

}
//CC卡号
export const SetDepositCardNumber_CC = (number = '', isRefresh = false) => {
    if (isRefresh) {
        const status = { number: '', numberErrMsg: '' }
        const action = {
            type: 'DEPOSIT_CARD_NUMBER_CC',
            data: status,
        };
        return action;
    }
    
    let numberErrMsg = ''
    const numericNumber = number.replace(/\D/g, ''); // Remove non-numeric characters
    
    if (numericNumber === '') {
        numberErrMsg = 'Số SERI không được để trống'
    } else if (!CCNumberReg.test(numericNumber)) {
        numberErrMsg = 'Số SERI phải bao gồm 16 chữ số'
    }
    
    const status = { number: numericNumber, numberErrMsg }
    const action = {
        type: 'DEPOSIT_CARD_NUMBER_CC',
        data: status,
    };
    return action;
}
//CC卡密码
export const SetDepositCardPIN_CC = (PIN = '', isRefresh = false) => {

    if (isRefresh) {
        const status = { PIN: '', PINErrMsg: '' }
        const action = {
            type: 'DEPOSIT_CARD_PIN_CC',
            data: status,
        };
        return action;
    }

    let PINErrMsg = ''
    const numericPIN = PIN.replace(/\D/g, ''); // Remove non-numeric characters
    
    if (numericPIN === '') {
        PINErrMsg = 'Số PIN không được để trống'
    } else if (!CCPINReg.test(numericPIN)) {
        PINErrMsg = 'Số PIN phải bao gồm 10 chữ số'
    }
    
    const status = { PIN: numericPIN, PINErrMsg }
    const action = {
        type: 'DEPOSIT_CARD_PIN_CC',
        data: status,
    };
    return action;
}

//取消存款
export const PostMemberCancelDeposit = (data = {}) => {
    const { transactionId } = GetDepositPayments() || {}

    return (dispatch, getState) => {
        dispatch(SetDepositNextStep());
        const { toastTip, ApiPost } = GetParamsData()
        return ApiPost(PayApiPort.MemberCancelDeposit + `transactionId=${transactionId || ''}&`,)
            .then((res) => {
                const { toastTip } = GetParamsData() || {}
                if (res?.isSuccess && res?.result?.isSuccess) {
                    toastTip.success(res?.result?.message || 'Tiền gửi đã bị hủy.', 2)
                }
                const action = {
                    type: 'MEMBER_CANCEL_DEPOSIT',
                    data: res,
                };
                return dispatch(action)

            })
            .catch((error) => {
                const action = {
                    type: 'MEMBER_CANCEL_DEPOSIT',
                    data: {},
                };
                return dispatch(action)
            });
    };

}
//旧账户存款
export const SetDepositOldBank = (data = false) => {
    return (dispatch, getState) => {
        const { webPiwikEvent, webPiwikUrl, appPiwikEvent, device } = GetParamsData()
        const {MethodCodeActive, DepositOldBank} =  getState();
        const { methods } = GetMethodsActive()
        if (device === 'APP') {
            if (data) {
                appPiwikEvent({
                    category: 'Deposit',
                    action: 'Toggle to Old Bank',
                    name: `Deposit_${methods}_C_Old_Bank`,
                    path: `deposit_${methods?.toLocaleLowerCase()}`,
                    title: `${methods} Deposit Page`
                })
            }
        } else {
            if(data){
                webPiwikEvent("Deposit", "Toggle to Old Bank", `Deposit_${methods}_${MethodCodeActive}_C_Old_Bank`)
                webPiwikUrl("deposit_old_bank", "Old Bank Deposit Page")
            }else if(DepositOldBank && !data){
                webPiwikUrl(`deposit_${MethodCodeActive.toLocaleLowerCase()}`, `${MethodCodeActive} Dopisit Page`)
            }
        }
        const action = {
            type: 'DEPOSIT_OLD_BANK',
            data: data,
        };
        return dispatch(action);
    }

}

export const SetCopyKey = (data = '') => {
    return (dispatch, getState) => {
        const action = {
            type: 'COPY_KEY',
            data: data,
        };
        return dispatch(action);
    }
}
//判断LB是否可以存款
export const GetDepositAccountByAmount = (remove = false) => {


    return (dispatch, getState) => {
        if(remove) {
            const action = { type: 'DEPOSIT_ACCOUNT_BY_AMOUNT', data: {} }
            return dispatch(action)
        }
        const { toastTip, ApiGet } = GetParamsData()
        const { enBankName, isAutoAssign = false } = GetDepositBankActive()
        const { money } = GetDepositMoneyStatus()
        const { methods } = GetMethodsActive()
        const { memberCode } = GetMenber()
        const methodCode = GetMethodCodeActive() || 'DEFAULT'

        let params = isAutoAssign
            ? `amount=${money}&paymentMethod=LB&paymentMethodCode=${methodCode}&`
            : `depositingBankName=${enBankName}&amount=${money}&paymentMethod=LB&paymentMethodCode=${methodCode}&`;

        toastTip.loading('Đang tải...')
        return ApiGet(PayApiPort.DepositAccountByAmount + params)
            .then((res) => {
                toastTip.hide()
                let datas = ''
                if(res.isSuccess) {
                    datas = res.result
                }
                // res.result.isDummyBank = true
                const action = { type: 'DEPOSIT_ACCOUNT_BY_AMOUNT', data: datas }
                const { webPiwikEvent, webPiwikUrl, appPiwikEvent, device } = GetParamsData();
                if (device === 'APP') {
                    const { methods = '', name = '' } = GetMethodsActive() || {}
                    const { DepositTriggerFrom = {} } = getState();
                    const { from, vendor = {} } = DepositTriggerFrom;
                    let vendorPiwikName = 'In' + vendor?.piwikName || ''
                    let data = {
                        category: from === "inGame" ? vendorPiwikName : 'Deposit',
                        action: from === "inGame" ? `Submit Deposit ${methods}` : `Submit Deposit Local Bank`,
                        name: from === "inGame" ? `${vendorPiwikName}_S_${methods}_Deposit` : `Deposit_LB_S_Deposit`,
                        path: from === "inGame" ? vendorPiwikName?.toLocaleLowerCase() : `deposit_local_bank`,
                        title: from === "inGame" ? vendorPiwikName : `Local Bank Deposit Page`,
                        isSuccess: res.isSuccess ? 2 : 1
                    }

                    if (res.isSuccess) {
                        if (from === "inGame") {
                            data.customProperties = {
                                [`${vendorPiwikName}_S_${methods}_Deposit_Amount`]: money
                            }
                        } else {
                            data.customProperties = {
                                [`Deposit_LB_S_Deposit_Amount`]: money
                            }
                        }
                    }


                    if (!res.isSuccess) {
                        if (from === "inGame") {
                            data.customProperties = {
                                [`${vendorPiwikName}_S_${methods}_Deposit_ErrorMsg`]: ''
                            }
                        } else {
                            data.customProperties = {
                                [`Deposit_LB_S_Deposit_ErrorMsg`]: '',
                            }
                        }
                    }

                    appPiwikEvent(data)
                }
                dispatch(SetDepositNextStep(true))
                return dispatch(action)
            })
            .catch((error) => {
                console.log('error in GetDepositAccountByAmount ',error)
                toastTip.hide()
                const action = { type: 'DEPOSIT_ACCOUNT_BY_AMOUNT', data: '' }
                toastTip.error("failed to get DepositAccountByAmount")
                return dispatch(action)
            });
    };
}

//清空所有状态,金额，银行，
export const RemoveAllReducers = (data = false) => {
    return (dispatch, getState) => {
        dispatch(SetDepositMoneyStatus('', '', true))
        dispatch(SetLBOfflineRefNo('', '', true))
        dispatch(SetDepositOldBankSixNumberStatus('', true))
        dispatch(SetDepositCardNumber_CC('', true))
        dispatch(SetDepositCardPIN_CC('', true))
        dispatch(RemoveUploadFile())
        dispatch(SetDepositNextStep())
        dispatch(SetDepositOldBank())
        !data && dispatch(ClearDepositPayments())

        const action = {
            type: 'REMOVE_ALL_REDUCERS',
            data: data,
        };
        return dispatch(action);
    }

}
// AnnouncementPopup公告
let announcementStorage = { updatedAt: '', }//用时间来判断是否再次显示
export const GetAnnouncementPopup = () => {
    return (dispatch, getState) => {
        
        let announcement = {}
        const { toastTip, ApiGet } = GetParamsData()
        return ApiGet(PayApiPort.AnnouncementPopup + 'optionType=Deposit&')
            .then((res) => {
                if (res && res.isSuccess && res.result) {
                    const { updatedAt } = GetStorage('AnnouncementPopup') || {}
                    if(updatedAt != res.result.updatedAt) {
                        //没有缓存设置显示
                        announcement = res.result
                        announcementStorage.updatedAt = res.result.updatedAt
                    }
                }
                const action = { type: 'ANNOUNCEMENT_POPUP', data: announcement }
                return dispatch(action)

            })
            .catch((error) => {
                const action = { type: 'ANNOUNCEMENT_POPUP', data: {} }
                return dispatch(action)
            });
    };
}
export const RemoveAnnouncementPopup = () => {
    return (dispatch, getState) => {
        const action = {
            type: 'ANNOUNCEMENT_POPUP',
            data: {},
        };
        return dispatch(action);
    }
}
//获取memberInfo
export const GetMemberInfo = () => {
    const {webPiwikUrl} = GetParamsData();
    return (dispatch, getState) => {
        let memberInfo = {}
        const { toastTip, ApiGet, goFinishMemberInfo, depositingWallet, webPiwikUrl } = GetParamsData()
        return ApiGet(PayApiPort.Member)
            .then((res) => {
                if (res && res.isSuccess) {
                    memberInfo = res.result && res.result.memberInfo || {}
                    const { firstName, loginOTP, preferWallet = 'MAIN' } = memberInfo
                    if(!firstName) {
                        //添加姓名
                        toastTip.hide()
                        webPiwikUrl("​deposit_verification_reminder_popup​","1st Deposit Verification​​")
                        goFinishMemberInfo()
                    }else if(loginOTP) {
                        //otp
                        toastTip.hide()
                        dispatch(SetLoginOTP(true))
                    } else {
                        //紧急公告弹窗，
                        // dispatch(GetAnnouncementPopup())//紧急公告不放在payment里面
                    }
                    if(!depositingWallet) {
                        //设置首选账户
                        setFEWalletParam('depositingWallet', preferWallet)
                    }
                }
                const action = { type: 'MEMBERINFO', data: memberInfo }
                return dispatch(action)

            })
            .catch((error) => {
                const action = { type: 'MEMBERINFO', data: {} }
                return dispatch(action)
            });
    };
}
export const SetLoginOTP = (data = false) => {
    return (dispatch, getState) => {
        const action = {
            type: 'LOGIN_OTP',
            data: data,
        };
        return dispatch(action);
    }
}
const refNoRegObj = {
    VCB: VCBrefNoReg,
    TEC: TECrefNoReg,
    SAC: SACrefNoReg
}
export const SetLBOfflineRefNo = (data = '', bankCode, isRefresh = false) => {
    if (isRefresh) {
        const refNoStatus = { refNo: '', refNoErrMsg: '' }
        const action = {
            type: 'LBOFFLINEREFNO',
            data: refNoStatus,
        };
        return action;
    }

    let refNoErrMsg = ''
    if (data == '' && bankCode) {
        refNoErrMsg = 'Vui lòng nhập số tham chiếu'
    } else {
        if (bankCode) {
            let tempRefNoReg = refNoRegObj[bankCode.toLocaleUpperCase()]
            if (tempRefNoReg && !tempRefNoReg.test(data)) {
                refNoErrMsg = 'Định dạng số tham chiếu không đúng'
            }
        }
    } 

    const refNoStatus = { refNo: data, refNoErrMsg }
    console.log('isRefresh', data, isRefresh, refNoStatus)

    const action = {
        type: 'LBOFFLINEREFNO',
        data: refNoStatus,
    };
    return action;

}


// 首次充值，获取优惠
export const GetBounsList = ({ depositingWallet, bonusId, bonusRuleGroupId, money }) => {
    return (dispatch, getState) => {
        const { toastTip, ApiGet } = GetParamsData()
        return ApiGet(PayApiPort.Bonus + "transactionType=Deposit&wallet=" + depositingWallet + "&", "GET").then(res => {
            let { isSuccess, result } = res
            let BonusAmount = 0
            let TurnoverAmount = 0
            if (isSuccess && Array.isArray(result) && result.length) {
                let bounsList = result.find(v => v.id == bonusId || v.groupID == bonusRuleGroupId) || {}
                if (Object.keys(bounsList).length) {
                    BonusAmount = Number(money) * bounsList.givingRate > bounsList.maxGiving
                        ? bounsList.maxGiving.toFixed(2)
                        : (Number(money) * bounsList.givingRate).toFixed(2)

                    let bonus = Number(money) * bounsList.givingRate // 紅利

                    if (bonus >= bounsList.maxGiving) {
                        let max = bounsList.maxGiving / bounsList.givingRate
                        TurnoverAmount = ((max + bounsList.maxGiving) * bounsList.releaseValue).toFixed(2)
                    } else {
                        TurnoverAmount = ((Number(money) + bonus) * bounsList.releaseValue).toFixed(2)
                    }
                }
            }
            const action = { type: 'DEPOSIT_BOUNS', data: { BonusAmount, TurnoverAmount } }
            return dispatch(action)
        }).catch((error) => {
            const action = { type: 'DEPOSIT_BOUNS', data: {} }
            return dispatch(action)
        });
    };
}

export const setDepositTriggerFrom = (data) => {
    return (dispatch, getState) => {
        const action = {
            type: 'DEPOSIT_TRIGGER',
            data:data,
        };
        return dispatch(action);
    }
}




















